<script>
    import Button from "./Button.svelte";

    export let data;
</script>
<Button bind:data={data}/>
